import { hasValue } from "../../../utils/functions.js";
import dateField from "../../common/date-field";
import DecimalField from "../../common/decimal-field.vue";
import SummaryCard from "../../sub-components/Generic/SummaryCard.vue";
export default {
  name: "pix-direto-em-conta",
  components: {
    dateField,
    SummaryCard,
    DecimalField
  },
  data: function () {
    return {
      filtro: this.FiltroPadrao(),
      contadorFiltro: 0,
      paginacao: {
        NumeroDaPagina: 1,
        RegistrosPorPagina: 10,
        TotalDeItens: 0
      },
      carregandoInstituicoesPagamento: false,
      carregandoPixDiretoEmConta: false,
      carregandoPixDiretoEmContaValorTotalAguardandoAcao: false,
      carregandoAtualizacao: false,
      validarObservacao: false,

      pixDiretoEmContaSelecionado: null,
      observacaoEscrita: null,
      idPixDiretoEmContaStatusSelecionado: null,

      listaBancosTrabalhaPix: [],
      listaPixDiretoEmConta: [],
      valorTotalAguardandoAcao: {
        style: "color: red",
        amount: 0, 
      }
    };
  },
  computed: {
    estaCarregandoInicio(){
      return this.carregandoInstituicoesPagamento;
    },
    estaCarregandoLista(){
      return this.carregandoPixDiretoEmConta || this.carregandoAtualizacao || this.carregandoPixDiretoEmContaValorTotalAguardandoAcao;
    },
    mensagemConfirmacaoObservacao(){
      if(this.pixDiretoEmContaSelecionado != null && this.idPixDiretoEmContaStatusSelecionado != null && !this.estaCarregandoInicio){
        const valor = this.$options.filters.currency(this.pixDiretoEmContaSelecionado.Valor);
        const nome = this.pixDiretoEmContaSelecionado.Nome;
        const documento = this.$options.filters.identity(this.pixDiretoEmContaSelecionado.Documento);
        const dataHora = this.$options.filters.date(this.pixDiretoEmContaSelecionado.DataHora, "DD/MM/YYYY [às] HH:mm:ss");
        return `Você tem certeza que deseja definir como <b>${this.statusSelecionado}</b> o PIX de <b>${valor}</b> `+
               `recebido de <b>${nome}</b> (CPF/CNPJ <b>${documento}</b>) feito em <b>${dataHora}</b> ?`;
      }
      else
        return "Carregando Mensagem...";
    },
    usuarioPixSelecionado(){
      if(this.pixDiretoEmContaSelecionado != null && this.pixDiretoEmContaSelecionado.UsuarioInternoObservacao != null
        && this.pixDiretoEmContaSelecionado.UsuarioInternoObservacao.Id > 0)
        return this.pixDiretoEmContaSelecionado.UsuarioInternoObservacao.Name;
      else
        return null;
    },
    statusSelecionado(){
      return this.pixDiretoEmContaStatus[this.idPixDiretoEmContaStatusSelecionado];
    },
    pixDiretoEmContaStatus(){
      return {
        '1':"Aguardando Ação",
        '2':"Estornado",
        '3':"Estornado Manualmente",
        '4':"Transferência Entre Contas",
        '5':"Recebimento Safe2Pay"
      }
    },
    infoBancosPorCodigo(){
      return {
        3:{
          Imagem: require("@/assets/images/bank_0001.png"),
          Agencia: "5745-2",
          Conta: "3959-4",
        },
        5:{
          Imagem:require("@/assets/images/bank_0033.png"),
          Agencia: "2088-5",
          Conta: "130022031",
        },
        21:{
          Imagem:require("@/assets/images/bank_0237.jpg"),
          Agencia: "0558-4",
          Conta: "13978-5",
        }
      }
    }
  },
  watch: {
    "paginacao.NumeroDaPagina": function () {
      this.PixDiretoEmContaListar();
    },
    "paginacao.RegistrosPorPagina": function () {
      this.PixDiretoEmContaListar();
    }
  },
  mounted() {
    this.InstituicoesPagamentoListar();
    this.PixDiretoEmContaBuscarValorTotalAguardandoAcao();
    this.PixDiretoEmContaListar();
  },
  methods: {
    //#region Consultas de inicio
    InstituicoesPagamentoListar() {
      this.carregandoInstituicoesPagamento = true;
      this.$store
        .dispatch("ListGateway", {})
        .then(resposta => {
          this.listaBancosTrabalhaPix = resposta
            .map(instituicaoPagamento => this.ParseBancos(instituicaoPagamento))
            .filter(banco => banco);
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar os bancos", error);
        })
        .finally(() => (this.carregandoInstituicoesPagamento = false));
    },
    //#endregion
    //#region Pesquisa
    AbrirModalFiltro() {
      this.$bvModal.show("mFiltro");
    },
    Filtrar() {
      this.$bvModal.hide("mFiltro");
      this.PixDiretoEmContaListar();
    },
    ReiniciarFiltro() {
      this.filtro = this.FiltroPadrao();
      this.PixDiretoEmContaListar();
    },
    FiltroPadrao() {
      return {
        IdBanco: null,
        IdPixDiretoEmContaStatus: null,
        Documento: null,
        Nome: null,
        Valor: null,
        PeriodoInicial: null,
        PeriodoFinal: null
      };
    },
    PixDiretoEmContaBuscarValorTotalAguardandoAcao() {
      this.carregandoPixDiretoEmContaValorTotalAguardandoAcao = true;
      const idPixDiretoEmContaStatus = 1;
      
      this.$store
        .dispatch("PixDiretoEmContaBuscarValorTotalPorStatus", idPixDiretoEmContaStatus)
        .then(response => {
          this.valorTotalAguardandoAcao.amount = response;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro carregar valor total", error);
        })
        .finally(() => (this.carregandoPixDiretoEmContaValorTotalAguardandoAcao = false));
    },
    PixDiretoEmContaListar() {
      this.contadorFiltro = 0;
      Object.values(this.filtro).forEach(itemFiltro => this.contadorFiltro += hasValue(itemFiltro));

      this.carregandoPixDiretoEmConta = true;
      let data = {
        ...this.paginacao,
        ...this.ParseFiltro(this.filtro)
      };
      delete data.TotalDeItens;
      this.$store
        .dispatch("PixDiretoEmContaListar", data)
        .then(response => {
          this.listaPixDiretoEmConta = response.Objetos;
          this.paginacao.TotalDeItens = response.TotalDeItens;
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao listar Pix's", error);
        })
        .finally(() => (this.carregandoPixDiretoEmConta = false));
    },
    //#endregion
    //#region Aux
    ParseBancos(objetoInstituicaoPagamento) {
      let retorno = null;
      const infoBanco = Object.keys(this.infoBancosPorCodigo).find(codigoBanco => codigoBanco == objetoInstituicaoPagamento.Code);
      if(infoBanco != undefined){
        retorno = {
          Id: objetoInstituicaoPagamento.Id,
          Nome: objetoInstituicaoPagamento.Name
        }
      }
      return retorno;
    },
    ParseFiltro(filtro) {
      return {
        PeriodoInicial: filtro.PeriodoInicial,
        PeriodoFinal: filtro.PeriodoFinal,
        "Objeto.Documento": filtro.Documento,
        "Objeto.Nome": filtro.Nome,
        "Objeto.Valor": filtro.Valor,
        "Objeto.Banco.Id": filtro.IdBanco,
        "Objeto.IdPixDiretoEmContaStatus": filtro.IdPixDiretoEmContaStatus,
      }
    },
    //#endregion
    //#region Atualizar informações
    AlterarStatus(pixDiretoEmConta, idPixDiretoEmContaStatus){
      this.idPixDiretoEmContaStatusSelecionado = idPixDiretoEmContaStatus;
      this.pixDiretoEmContaSelecionado = pixDiretoEmConta;
      this.$bvModal.show("mObservacao");
    },
    CancelarAlterarStatus(){
      this.idPixDiretoEmContaStatusSelecionado = null;
      this.pixDiretoEmContaSelecionado = null;
      this.validarObservacao = false;
      this.$bvModal.hide("mObservacao");
    },
    ConfirmarAtualizacao() {
      this.validarObservacao = true;
      this.$refs.ValidacaoObservacao.validate().then(
        (ehValido) => {
          if (ehValido) {
            const metodoUtilizado = this.idPixDiretoEmContaStatusSelecionado != "2" ? this.AtualizarStatus : this.RequisitarDevolucao;
            this.$makeMsgBox(
              `Você tem certeza que deseja definir esse Pix como ${this.statusSelecionado} ?`,
              "Confirmar",
              metodoUtilizado
            );
          }
        });
    },
    AtualizarStatus(){
      this.carregandoAtualizacao = true;
      const pixDiretoEmContaAAtualizar = {
        Id: this.pixDiretoEmContaSelecionado.Id,
        Observacao: this.observacaoEscrita,
        IdPixDiretoEmContaStatus: this.idPixDiretoEmContaStatusSelecionado
      };
      this.$store
        .dispatch("PixDiretoEmContaAtualizar", pixDiretoEmContaAAtualizar)
        .then(resposta => {
          if(resposta){
            this.$makeToast("Status alterado com sucesso", "success", "Alteração de status");
            this.PixDiretoEmContaListar();
          }
          else
            this.$makeToast("Não foi possivel alterar o status", "danger", "Alteração de status", error);
          this.CancelarAlterarStatus();
        })
        .catch(error => {
          this.$makeToast(undefined, "danger", "Erro ao tentar alterar os status", error);
        })
        .finally(() => (this.carregandoAtualizacao = false));
    },
    RequisitarDevolucao(){
      this.carregandoAtualizacao = true;
      const pixDiretoEmContaAAtualizar = {
        Id: this.pixDiretoEmContaSelecionado.Id,
        Observacao: this.observacaoEscrita,
        Banco: this.pixDiretoEmContaSelecionado.Banco
      };
      this.$store
        .dispatch("PixDiretoEmContaEstornar", pixDiretoEmContaAAtualizar)
        .then(resposta => {
          if(resposta){
            this.$makeToast("Pix estornado com sucesso", "success", "Estorno");
            this.PixDiretoEmContaListar();
          }
          else
            this.$makeToast("Erro ao tentar estornar esse pix direto", "danger", "Estorno", error);
          this.CancelarAlterarStatus();
        })
        .catch(error => {
          this.$makeToast("Erro ao tentar estornar esse pix direto", "danger", "Estorno", error);
        })
        .finally(() => (this.carregandoAtualizacao = false));
    },
    //#endregion
    //#region Visualizar informações
    AbrirVisualizar(pixDiretoEmConta){
      this.pixDiretoEmContaSelecionado = pixDiretoEmConta;
      this.$bvModal.show("mVisualizacao");
    },
    FecharVisualizar(){
      this.pixDiretoEmContaSelecionado = null;
      this.$bvModal.hide("mVisualizacao");
    },
    //#endregion
  }
};


// WEBPACK FOOTER //
// ./src/components/pages/PixDiretoEmConta/PixDiretoEmConta.js